import { jsonApiClient } from 'shared/model';
import { LocationScoreTypeSetting } from '../@types';

const api = jsonApiClient('ScoreTypeSetting');

export const postScoreTypeSettings = (scoreTypeSetting: LocationScoreTypeSetting) => api.post<LocationScoreTypeSetting>(undefined, scoreTypeSetting);
export const getScoreTypeSettings = (scoreTypeId: string, locationId?: string, signal?: AbortSignal) =>
  api.get<LocationScoreTypeSetting>(locationId ? `${scoreTypeId}/${locationId}` : `${scoreTypeId}`, { signal });
